import { SubAgentEntity } from 'entities/SubAgent';

import { SubAgentStore } from './SubAgentStore';

export type CreateSubAgentStoreOptions = {
  onCreated: () => void;
  onNextStep: () => void | Promise<void>;
};

export class CreateSubAgentStore extends SubAgentStore {
  private readonly _onNextStep: CreateSubAgentStoreOptions['onNextStep'];

  /** появляется после успешного создания субагента */
  createdSubAgent?: SubAgentEntity;

  constructor({ onCreated, onNextStep }: CreateSubAgentStoreOptions) {
    super({
      onSuccess: ({ isCreated, createdSubAgent }) => {
        if (isCreated && createdSubAgent) {
          this.createdSubAgent = createdSubAgent;
          onCreated();
        }
      },
    });

    this._onNextStep = onNextStep;
  }

  nextStep = async () => {
    if (!this.validateFields()) {
      return;
    }

    await this._onNextStep();
  };
}
